"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataQualityWarningField = void 0;
var components_1 = require("@apollo/client/react/components");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var queries_1 = require("../../../gen-src/queries");
var renderQueryResult_1 = require("../renderQueryResult");
var DataQualityWarningColumn_1 = require("./DataQualityWarningColumn");
var renderWarningQueryResult_1 = require("./renderWarningQueryResult");
/** @deprecated TFS1478812 */
function DataQualityWarningField(_a) {
    var fieldId = _a.fieldId, source = _a.source;
    var urls = react_1.default.useContext(data_catalog_shared_1.SiteUrlsContext);
    var publishedConnectionsLineageEnabled = react_1.default.useContext(data_catalog_shared_1.FeatureFlagsContext).publishedConnectionsLineageEnabled;
    var renderers = react_1.default.useMemo(function () { return (0, renderWarningQueryResult_1.renderWarningQueryResult)(renderWarnings(urls, source)); }, [urls, source]);
    return (react_1.default.createElement(components_1.Query, { query: queries_1.FieldDirectColumnDataQualityWarningsDocument, variables: { fieldId: fieldId, publishedConnectionsLineageEnabled: publishedConnectionsLineageEnabled } }, function (result) { return react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: renderers }); }));
}
exports.DataQualityWarningField = DataQualityWarningField;
function renderWarnings(urls, source) {
    return function (data) {
        var _a, _b;
        var field = data.fields && data.fields[0] ? data.fields[0] : null;
        if (!field) {
            return null;
        }
        var columns = field.__typename === 'ColumnField' ? (_b = (_a = field.columnsConnection) === null || _a === void 0 ? void 0 : _a.nodes) !== null && _b !== void 0 ? _b : [] : [];
        if (columns.length < 1) {
            return null;
        }
        var upstreamWarnings = [];
        columns.forEach(function (c) { return c.dataQualityWarnings.forEach(function (w) { return upstreamWarnings.push(__assign({}, w)); }); });
        var props = {
            subjectArea: 'Field',
            kind: 'graph',
            anchoredAsset: null,
            anchoredWarnings: [],
            iconOnly: false,
            urls: urls,
            upstreamWarnings: upstreamWarnings,
            source: source !== null && source !== void 0 ? source : 'DataQualityWarningField',
        };
        return (react_1.default.createElement(DataQualityWarningColumn_1.DialogWarningStatusChipWrapper, null,
            react_1.default.createElement(data_catalog_shared_1.WarningStatusChip, __assign({}, props))));
    };
}
//# sourceMappingURL=DataQualityWarningField.js.map